// Components
import { TDecodedToken } from '../types';

const isTokenValid = (token: string): boolean => {
  try {
    const payload: TDecodedToken = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp > currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return false;
  }
};

const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("UnauthorizedPage: No token found.");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const decodeToken = (token: string): TDecodedToken => {
  try {
    const payload = token.split(".")[1];

    const decodedPayload = atob(payload);

    const parsedPayload: TDecodedToken = JSON.parse(decodedPayload);

    if (parsedPayload.exp * 1000 < Date.now()) {
      throw new Error("Token has expired");
    }

    return parsedPayload;
  } catch (error) {
    console.error("Failed to decode token:", error);
    throw new Error("Invalid token");
  }
};


export { isTokenValid, getAuthHeaders, decodeToken };
